import 'core-js/stable'
import 'regenerator-runtime'
import 'isomorphic-fetch';

import "sanitize.css";

import '../resources/base';
import '../resources/config';
import '../resources/helpers';
import '../resources/layout';

import '../resources/elements/_table.scss';

import '../resources/sitewide.js';
import '../resources/styles.scss';
import '../resources/components/alert/alert.scss';
import '../resources/components/booking-summary/booking-summary.scss';
import '../resources/components/button/button.scss';
import '../resources/components/confirmation-form/confirmation-form.scss';
import '../resources/components/confirmation-form/index.js';
import '../resources/components/form/form.scss';
import '../resources/components/header/header.scss';
import '../resources/components/numpad/numpad.scss';
import '../resources/components/radio/radio.scss';
import '../resources/components/reports-table/reports-table.scss';
import '../resources/components/user-info/user-info.scss';

import '../resources/screens/homepage/homepage.scss';
import '../resources/screens/login/login.scss';
